import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import { DocumentPreviewContent } from "./DocumentPreviewContent";

const DocumentViewer = ({ open, onClose, documentUrl, documentName }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    fullWidth
    PaperProps={{
      style: {
        minHeight: "80vh",
        maxHeight: "90vh",
      },
    }}
  >
    <DialogTitle
      disableTypography
      style={{
        position: "relative",
        padding: "1rem 1rem 1rem 1.5rem",
        minHeight: "3.5rem",
        fontSize: "1.1rem",
        fontWeight: 600,
      }}
    >
      <span>{documentName || "Document Viewer"}</span>
      <button
        type="button"
        className="document-viewer__close-btn"
        onClick={onClose}
        aria-label="Close document viewer"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="#4a4a4a"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </DialogTitle>

    <DialogContent dividers>
      <DocumentPreviewContent
        documentUrl={documentUrl}
        documentName={documentName}
        enabled={open && Boolean(documentUrl)}
        compact={false}
        showDownload
      />
    </DialogContent>
  </Dialog>
);

DocumentViewer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  documentUrl: PropTypes.string,
  documentName: PropTypes.string,
};

DocumentViewer.defaultProps = {
  documentUrl: "",
  documentName: "Resume",
};

export default DocumentViewer;
